import { Component, OnInit } from '@angular/core';
import { IServiceFactory } from '../../Services/service-factory';
import { FilterService } from '../../Services/filter-service';

@Component({
  selector: 'app-collapse-expand-all-classes',
  templateUrl: './collapse-expand-all-classes.component.html',
  styleUrls: ['./collapse-expand-all-classes.component.scss']
})
export class CollapseExpandAllClassesComponent implements OnInit {

  filterService: FilterService;
  constructor(private serviceFactory: IServiceFactory) { }

  ngOnInit(): void {
    this.filterService = this.serviceFactory.getFilterService();
  }

  collapseAll(){
    this.filterService.emitCollapse();
  }

  expandAll(){
    this.filterService.emitExpand();
  }

}
